import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import { NAV } from "./Header";
import { Socials } from "./Socials";

export default function Footer() {
  const { config } = useSite();
  return (
    <footer data-testid="site-footer" className="border-t border-[#171715]/10 bg-[#F7F3EB]">
      <div className="container-lm py-10 grid gap-8 md:grid-cols-[1fr_auto_1fr] items-center">
        <Link to="/" className="font-display font-bold text-lg" data-testid="footer-logo">livemedia.az</Link>
        <nav className="flex flex-wrap gap-x-10 gap-y-3 text-[13px]" aria-label="Footer menyu">
          {NAV.map((n) => (
            <Link key={n.id} to={n.to} className="opacity-75 hover:opacity-100 transition-opacity" data-testid={`footer-nav-${n.id}`}>{n.label}</Link>
          ))}
        </nav>
        <div className="flex flex-col md:items-end gap-3">
          <Socials contacts={config.contacts} />
          <p className="text-xs text-[#77736B]">© {new Date().getFullYear()} livemedia.az. Bütün hüquqlar qorunur.</p>
          <Link to="/mexfilik" className="text-xs text-[#77736B] underline-offset-4 hover:underline" data-testid="footer-privacy-link">
            Məxfilik siyasəti və endirim şərtləri
          </Link>
        </div>
      </div>
    </footer>
  );
}
